module.exports = __webpack_public_path__ + "static/media/login_logo.b8cbe25a.png";